import styled, {css} from 'styled-components';
import {getObjectProp} from '../../utils/helpers/object';

export const StyledHeader = styled.header`
  ${({theme, disableDivider}) => css`
    position: sticky;
    left: 0;
    top: 0;
    width: 100%;
    height: 75px;
    color: inherit;
    display: flex;
    align-items: center;
    z-index: 1298;
    padding: 4px 16px 0 16px;
    background: ${getObjectProp(theme, 'vars.palette.grey.100')};

    ${theme.breakpoints.up('md')} {
      & {
        padding: 4px 32px 0 32px;
      }
    }

    ${!disableDivider &&
    css`
      border-bottom: 1px solid ${getObjectProp(theme, 'vars.palette.grey.400')};
    `}
  `}
`;
